<template>
  <div
    class="modal"
    tabindex="-1"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
          >
            Change Password
          </h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <change-user-password-form :entity="user" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChangeUserPasswordForm } from '../../forms';

export default {
  name: 'ChangeUserPasswordModal',
  components: { ChangeUserPasswordForm },
  props: {
    user: {
      type: Object,
      default: () => null
    }
  }
};
</script>
